import React, { lazy, useState } from "react";
// import Upload from "./Upload";
import first from "../assets/images/time.png";
import second from "../assets/images/reload.png";
import third from "../assets/images/device.png";
import upload from "../assets/images/upload.png";
import processing from "../assets/images/processing.png";
import download from "../assets/images/download.png";
import logo from "../assets/images/skyraaconverter.svg";
import Buttonimg from "../assets/images/buttonsgroup.svg";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import "./Mainpage.css";
import plus from "../assets/images/plus.svg";
import ResponsiveFormatsSection from "./ResponsiveFormatsSection";
const Upload = lazy(() => import("./Upload"));
function Mainpage() {
  const [isFaqOpen1, setIsFaqOpen1] = useState(false);
  const [isFaqOpen2, setIsFaqOpen2] = useState(false);
  const [isFaqOpen3, setIsFaqOpen3] = useState(false);
  const [isFaqOpen4, setIsFaqOpen4] = useState(false);

  return (
    <div>
      <div className=" mt-8  " style={{ placeItems: "center" }}>
        <Link to="/">
          <div className="w-[9rem] ">
            <img
              src={logo}
              alt="skyraa converter"
              className="w-[100%] h-[10%]"
              style={{ cursor: "pointer" }}
            />
          </div>
        </Link>
        <h1
          className="gradient-text text-[27px] md:text-[2.2rem] "
          style={{ cursor: "pointer" }}
        >
          Skyra Convertor
        </h1>
        <p className="px-6 md:px-24  lg:px-32 xl:px-64 text-center">
          We value your privacy. All images you upload are automatically deleted
          from our servers after 30 minutes, ensuring your data stays secure
          while you enjoy a fast, smooth, and hassle-free conversion experience
        </p>
      </div>
      {/* Horizontal Line with Three Colors */}
      <div className="  my-5">
        <div className="flex">
          <div className="flex-1 h-2 bg-red-500"></div>
          <div className="flex-1 h-2 bg-yellow-500"></div>
          <div className="flex-1 h-2 bg-green-500"></div>
        </div>
      </div>
      <div className=" text-center ">
        <div className="px-2 md:px-24  lg:px-32   xl:px-48">
          <Upload />
        </div>

        <h1 className="my-5">
          Why Choose{" "}
          <span className="" style={{ color: " #4285F4" }}>
            Skyra Convertor ?
          </span>{" "}
        </h1>

        <div className=" mx-2 md:mx-24 lg:mx-32 lg:mx-32 xl:mx-48 px-4 md:grid md:grid-cols-2  gap-4 md:gap-8 lg:gap-24  xl:gap-28 pb-[3rem] xl:pb-[5rem] ">
          <div
            className=" p-[30px] justify-items-center content-center rounded-[2.5rem]"
            style={{ boxShadow: "#D2E3FF 0px 0px 8px 1px" }}
          >
            <div
              className="w-[85px] h-[85px]    md:h-[100px] md:w-[100px]"
              style={{}}
            >
              <img
                src={first}
                style={{ height: "100%", width: "100%" }}
                alt="lesstime"
              />
            </div>
            <h4 className="mt-3">Fast and easy</h4>
            <p className="faq-content text-gray-600">
              Just drop your files on the page, choose an output format and
              click "Convert" button. Wait a little for the process to complete.
              We aim to do all our conversions in under 1-2 minutes.
            </p>
          </div>
          <div className="mt-8  md:mt-0 ">
            <div
              className="justify-items-center p-[30px] mb-10 rounded-[2.5rem]"
              style={{ boxShadow: "#D2E3FF 0px 0px 8px 1px" }}
            >
              <div style={{ height: "100px", width: "100px" }}>
                <img
                  className="w-[85px] h-[85px]    md:h-[100px] md:w-[100px]"
                  src={second}
                  style={{}}
                  alt="reuse easily"
                />
              </div>
              <h4 className="mt-3">300+ Formats supported</h4>
            </div>
            <div
              className="justify-items-center p-[30px] rounded-[2.5rem]"
              style={{ boxShadow: "#D2E3FF 0px 0px 8px 1px" }}
            >
              <div style={{ height: "100px", width: "100px" }}>
                <img
                  className="w-[85px] h-[85px]    md:h-[100px] md:w-[100px]"
                  src={third}
                  style={{}}
                  alt="responsive"
                />
              </div>
              <h4 className="mt-3 ">All Device supported</h4>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="text-center py-8 my-8 custom-cursor  " style={{}}>
        <h3 className="text-white  mb-5">All formates Supported</h3>
        <div className="flex mx-2 md:mx-16 lg:mx-32 gap-2 md:gap-4 lg:gap-8 justify-center my:8 md:my-8 lg:my-16 flex-wrap ">
          <button className=" cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            PNG
          </button>
          <button className=" cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            JPEG
          </button>
        </div>

        <div className="flex mx-2 md:mx-16 lg:mx-4 xl:mx-32 gap-2 md:gap-4 lg:gap-8 justify-center my-4 my:8 md:my-8 lg:my-16 flex-wrap ">
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            JPG
          </button>
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            SVG
          </button>
          <button className="btnhover text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            Convert
          </button>
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            WEPG
          </button>
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            TIFF
          </button>
        </div>

        <div className="flex mx-2 md:mx-16 lg:mx-32 gap-2 md:gap-4 lg:gap-8 justify-center my:8 md:my-8 lg:my-16 flex-wrap ">
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            PDF
          </button>
          <button className="cursor-auto text-[8px] md:text-[16px] text-green-700 bg-white px-4  py-1.5 md:px-8 lg:px-16 md:py-2.5 lg:py-3.5 rounded-full">
            AVIF
          </button>
        </div>
      </div> */}
      <ResponsiveFormatsSection />
      {/* <img className="mt-8  md:mt-16" src={Buttonimg} alt="convert formats" /> */}
      <div className="text-center my-8">
        <h3>How to Convert Images to any Format ?</h3>
      </div>
      <div className=" mx-2 md:mx-16 lg:mx-32  xl:mx-48 px-4 sm:flex sm:gap-12 sm:justify-center sm:items-center my-10">
        <div className=" justify-items-center my-10 md:my-0">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={upload}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3">1.Choose Images</h4>
          <p className="text-center faq-content text-gray-600">
            Easily upload your images or drag and drop them directly into your
            browser. No fuss — just a smooth start to your conversion.
          </p>
        </div>
        <div className="justify-items-center my-10 md:my-0 ">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={processing}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3 ">2.Start Conversion</h4>
          <p className="text-center faq-content text-gray-600">
            Choose your desired output format and optionally compress your image
            for faster sharing and optimized storage. Quick, easy, and
            high-quality every time.
          </p>
        </div>
        <div className="justify-items-center my-10 md:my-0">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={download}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3">3.Download Images</h4>
          <p className="text-center faq-content text-gray-600">
            Once the conversion (and optional compression) is complete, simply
            download your high-quality images instantly — quick, clean, and
            hassle-free.
          </p>
        </div>
      </div>

      <div className=" my-8">
        <h3 className="text-center">Frequently Asked Questions </h3>

        <div
          className=" mt-16 mb-14 mx-2 md:mx-16 lg:mx-32 xl:mx-48 p-[12px] lg:p-8 xl:p-16   "
          style={{ border: "2px solid #D9D9D9", borderRadius: "30px" }}
        >
          <div className="flex justify-between items-center">
            <p className="mb-4 text-[13px]  md:text-lg lg:text-xl text-justify font-semibold text-gray-800">
              Is there a limit on file size?
            </p>
            <img
              src={plus}
              alt="view_close"
              className={` w-[16px]   md:w-6 md:h-6 cursor-pointer transition-transform duration-300 ${
                isFaqOpen1 ? "rotate-45" : ""
              }`}
              onClick={() => setIsFaqOpen1(!isFaqOpen1)}
            />
          </div>
          <span
            className={`mb-3 pr-8 md:pr-12 lg:pr-8 xl:pr-0 faq-content block mt-2 text-gray-600 text-[10px] md:text-[13px] lg:text-base overflow-hidden transition-all duration-300 ${
              isFaqOpen1 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            Each image can be up to 5MB. Larger files may take a bit longer to
            upload and convert.
          </span>
          <hr className="mb-3" />
          <div className=" flex justify-between items-center">
            <p className="mb-4 text-[13px]  md:text-lg lg:text-xl text-justify font-semibold text-gray-800">
              How long are my files stored on Skyra Convertor?
            </p>
            <img
              src={plus}
              alt="view_close"
              className={`w-[16px]  md:w-6 md:h-6 cursor-pointer transition-transform duration-300 ${
                isFaqOpen2 ? "rotate-45" : ""
              }`}
              onClick={() => setIsFaqOpen2(!isFaqOpen2)}
            />
          </div>
          <span
            className={`mb-3 pr-8 md:pr-12 lg:pr-8 xl:pr-0 faq-content block mt-2 text-gray-600 text-[10px] md:text-[13px] lg:text-base overflow-hidden transition-all duration-300 ${
              isFaqOpen2 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            All files are automatically deleted after 30 minutes to ensure your
            privacy and security.
          </span>
          <hr className="mb-3" />
          <div className="flex justify-between items-center">
            <p className="mb-4 text-[13px]  md:text-lg lg:text-xl text-justify font-semibold text-gray-800">
              Can I compress images during conversion?
            </p>
            <img
              src={plus}
              alt="view_close"
              className={` w-[16px] md:w-6 md:h-6 cursor-pointer transition-transform duration-300 ${
                isFaqOpen3 ? "rotate-45" : ""
              }`}
              onClick={() => setIsFaqOpen3(!isFaqOpen3)}
            />
          </div>
          <span
            className={`mb-3 pr-8 md:pr-12 lg:pr-8 xl:pr-0 faq-content block mt-2 text-gray-600 text-[10px] md:text-[13px] lg:text-base overflow-hidden transition-all duration-300 ${
              isFaqOpen3 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            Yes! Skyra Convertor offers compression options to reduce file size
            while maintaining quality.
          </span>
          <hr className="mb-3" />
          <div className="flex justify-between items-center">
            <p className="mb-4 text-[13px]  md:text-lg lg:text-xl text-justify font-semibold text-gray-800">
              How fast is the conversion process?
            </p>
            <img
              src={plus}
              alt="view_close"
              className={`w-[16px] md:w-6 md:h-6 cursor-pointer transition-transform duration-300 ${
                isFaqOpen4 ? "rotate-45" : ""
              }`}
              onClick={() => setIsFaqOpen4(!isFaqOpen4)}
            />
          </div>
          <span
            className={`mb-3 pr-8 md:pr-12 lg:pr-8 xl:pr-0 faq-content block mt-2 text-gray-600 text-[10px] md:text-[13px] lg:text-base overflow-hidden transition-all duration-300 ${
              isFaqOpen4 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            Conversions are typically completed in seconds, depending on file
            size and connection speed.
          </span>
          <hr className="mb-3" />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Mainpage;
